// extracted by mini-css-extract-plugin
export default {"root":"footer-module__root--VKScY","socialsAndTimeWrapper":"footer-module__socialsAndTimeWrapper--GseID","additioinal":"footer-module__additioinal--rOyky"};